(function () {
  if (window.__cshowcaseInit) return;
  window.__cshowcaseInit = true;

  function getActiveCarousel(section) {
    if (!section) return null;
    var panel = section.querySelector('.tabs__panel:not([hidden])') || section;
    return panel.querySelector('carousel-slider');
  }

  function updateArrows(section) {
    if (!section) return;
    var prev = section.querySelector('[data-cshowcase-nav="prev"]');
    var next = section.querySelector('[data-cshowcase-nav="next"]');
    if (!prev || !next) return;

    var carousel = getActiveCarousel(section);
    var swiper = carousel && carousel.swiperInstance;

    if (!swiper || swiper.destroyed || swiper.params && swiper.params.loop) {
      prev.disabled = false;
      next.disabled = false;
      return;
    }
    var manyTabs = section.querySelectorAll('[role="tab"]').length > 1;
    prev.disabled = !!swiper.isBeginning && !manyTabs;
    next.disabled = !!swiper.isEnd && !manyTabs;
  }

  function openQuickView(button) {
    var card = button.closest('.cshowcase-card');
    var section = button.closest('.cshowcase');
    if (!card || !section) return;

    var template = card.querySelector('[data-cshowcase-qv-data]');
    var dialog = section.querySelector('.cshowcase__qv-dialog');
    var body = dialog && dialog.querySelector('[data-cshowcase-qv-body]');
    if (!template || !dialog || !body) return;

    function fill() {
      body.innerHTML = '';
      body.appendChild(template.content.cloneNode(true));
      var firstThumb = body.querySelector('[data-cshowcase-qv-thumb]');
      if (firstThumb) firstThumb.classList.add('is-active');
    }
    var qvUrl = template.getAttribute('data-qv-url');
    if (qvUrl && !template.content.firstElementChild) {
      body.innerHTML = '<div class="cshowcase__qv-loading" style="padding:4rem;text-align:center">…</div>';
      fetch(qvUrl.split('?')[0] + '.js')
        .then(function (r) { return r.json(); })
        .then(function (p) {
          var imgW = function (u, w) { return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; };
          var money = function (cents) {
            var fmt = (window.FoxTheme && window.FoxTheme.moneyFormat) || '{{amount}} TL';
            var amount = (cents / 100).toFixed(2).replace('.', ',');
            return fmt.replace(/\{\{\s*amount[^}]*\}\}/, amount);
          };
          var imgs = p.images || [];
          var html = '<div class="cshowcase-qv"><div class="cshowcase-qv__gallery"><div class="cshowcase-qv__main">';
          if (imgs.length) html += '<img class="cshowcase-qv__main-img" src="' + imgW(imgs[0], 1200) + '" loading="lazy" alt="">';
          html += '</div>';
          if (imgs.length > 1) {
            html += '<div class="cshowcase-qv__thumbs">';
            imgs.slice(0, 8).forEach(function (im) {
              html += '<button type="button" class="cshowcase-qv__thumb" data-cshowcase-qv-thumb data-src="' + imgW(im, 1200) + '"><img src="' + imgW(im, 160) + '" loading="lazy" alt=""></button>';
            });
            html += '</div>';
          }
          html += '</div><div class="cshowcase-qv__info"><h2 class="cshowcase-qv__title"></h2>';
          html += '<product-price class="cshowcase-qv__price"><span class="price"></span></product-price>';
          if (p.description) html += '<div class="cshowcase-qv__desc rte">' + p.description + '</div>';
          html += '<a href="' + qvUrl + '" class="cshowcase-qv__link btn btn--primary">' + (template.getAttribute('data-qv-label') || 'Ürünü incele') + '</a></div></div>';
          var tpl = document.createElement('template');
          tpl.innerHTML = html;
          tpl.content.querySelector('.cshowcase-qv__title').textContent = p.title;
          var priceHtml = money(p.price);
          if (p.compare_at_price && p.compare_at_price > p.price) priceHtml += ' <s style="opacity:.6">' + money(p.compare_at_price) + '</s>';
          tpl.content.querySelector('.price').innerHTML = priceHtml;
          template.content.replaceChildren(tpl.content.cloneNode(true));
          fill();
        })
        .catch(function () { body.innerHTML = ''; window.location.href = qvUrl; });
    } else {
      fill();
    }

    if (typeof dialog.showModal === 'function') {
      if (!dialog.open) dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
  }

  function closeQuickView(dialog) {
    if (!dialog) return;
    if (typeof dialog.close === 'function' && dialog.open) {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
    }
    var body = dialog.querySelector('[data-cshowcase-qv-body]');
    if (body) body.innerHTML = '';
  }

  function swapMainImage(thumb) {
    var gallery = thumb.closest('.cshowcase-qv');
    if (!gallery) return;
    var main = gallery.querySelector('.cshowcase-qv__main-img');
    var src = thumb.getAttribute('data-src');
    if (main && src) {
      main.src = src;
      var srcset = thumb.getAttribute('data-srcset');
      if (srcset) main.srcset = srcset;
    }
    gallery.querySelectorAll('[data-cshowcase-qv-thumb]').forEach(function (t) {
      t.classList.toggle('is-active', t === thumb);
    });
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!(target instanceof Element)) return;

    var qvButton = target.closest('[data-cshowcase-qv]');
    if (qvButton) {
      event.preventDefault();
      event.stopPropagation();
      openQuickView(qvButton);
      return;
    }

    var thumb = target.closest('[data-cshowcase-qv-thumb]');
    if (thumb) {
      event.preventDefault();
      swapMainImage(thumb);
      return;
    }

    var closeButton = target.closest('[data-cshowcase-qv-close]');
    if (closeButton) {
      event.preventDefault();
      closeQuickView(closeButton.closest('.cshowcase__qv-dialog'));
      return;
    }

    if (target.classList && target.classList.contains('cshowcase__qv-dialog')) {
      closeQuickView(target);
      return;
    }

    var navButton = target.closest('[data-cshowcase-nav]');
    if (navButton) {
      event.preventDefault();
      var section = navButton.closest('.cshowcase');
      var dir = navButton.getAttribute('data-cshowcase-nav') === 'next' ? 1 : -1;
      var carousel = getActiveCarousel(section);
      var swiper = carousel && carousel.swiperInstance;
      var moved = false;
      if (swiper && !swiper.destroyed) {
        var canMove = dir > 0 ? !swiper.isEnd : !swiper.isBeginning;
        // loop acik gorunse bile slide sayisi yetmiyorsa swiper loop'u ic ice iptal eder;
        // gercek loop'ta isEnd/isBeginning zaten false oldugundan ayrica kontrol gerekmez.
        if (canMove) {
          if (dir > 0) swiper.slideNext();
          else swiper.slidePrev();
          moved = true;
        }
      }
      if (!moved) {
        // Kaydirilacak urun kalmadiysa (veya swiper yoksa) sekme degistir
        var tabs = Array.prototype.slice.call(section.querySelectorAll('[role="tab"]'));
        if (tabs.length > 1) {
          var cur = tabs.findIndex(function (t) {
            return t.getAttribute('aria-selected') === 'true' || t.classList.contains('is-active') || t.getAttribute('aria-expanded') === 'true';
          });
          if (cur < 0) cur = 0;
          var nxt = (cur + dir + tabs.length) % tabs.length;
          tabs[nxt].click();
          tabs[nxt].scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
          var nc = getActiveCarousel(section);
          if (nc && nc.swiperInstance && !nc.swiperInstance.destroyed) nc.swiperInstance.slideTo(0);
        }
      }
      window.setTimeout(function () {
        updateArrows(section);
      }, 80);
      return;
    }
  });

  document.addEventListener('cancel', function (event) {
    var dialog = event.target;
    if (dialog instanceof Element && dialog.classList.contains('cshowcase__qv-dialog')) {
      var body = dialog.querySelector('[data-cshowcase-qv-body]');
      if (body) body.innerHTML = '';
    }
  });

  function initArrows() {
    document.querySelectorAll('.cshowcase').forEach(function (section) {
      updateArrows(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      window.setTimeout(initArrows, 300);
    });
  } else {
    window.setTimeout(initArrows, 300);
  }

  // 15 Eki (hız): ilk sekme dışındaki sekmeler sunucuda boş gelir (data-cs-uzak). Bölüm ekrana
  // yaklaşınca aynı bölüm Section Rendering API ile bir kez istenir, sekme içerikleri temanın kendi
  // <template> düzenine konur (sekme açılınca tabs-component klonlar). Erken tıklanırsa doğrudan basılır.
  function sekmeleriGetir(section) {
    if (section.__csIstek) return section.__csIstek;
    var kutu = section.closest('.shopify-section');
    var id = kutu && kutu.id.replace(/^shopify-section-/, '');
    if (!id) return null;
    var url = window.location.pathname + '?section_id=' + encodeURIComponent(id);
    section.__csIstek = fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        section.querySelectorAll('.tabs__panel[data-cs-uzak]').forEach(function (panel) {
          var kaynak = doc.getElementById(panel.id);
          var tpl = kaynak && kaynak.querySelector('template');
          if (!tpl) return;
          var once = panel.querySelector('.cshowcase__more');
          if (panel.dataset.loaded === 'true') {
            panel.insertBefore(document.importNode(tpl.content, true), once);
          } else {
            var yeni = document.createElement('template');
            yeni.innerHTML = tpl.innerHTML;
            panel.insertBefore(yeni, once);
          }
          panel.removeAttribute('data-cs-uzak');
        });
        updateArrows(section);
      })
      .catch(function () { section.__csIstek = null; });
    return section.__csIstek;
  }

  function uzakSekmeler() {
    document.querySelectorAll('.cshowcase').forEach(function (section) {
      if (section.__csIzle || !section.querySelector('.tabs__panel[data-cs-uzak]')) return;
      section.__csIzle = true;
      section.addEventListener('pointerenter', function () { sekmeleriGetir(section); }, { once: true });
      section.addEventListener('focusin', function () { sekmeleriGetir(section); }, { once: true });
      if (!('IntersectionObserver' in window)) { sekmeleriGetir(section); return; }
      var io = new IntersectionObserver(function (entries) {
        if (entries.some(function (e) { return e.isIntersecting; })) { io.disconnect(); sekmeleriGetir(section); }
      }, { rootMargin: '1000px 0px' });
      io.observe(section);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', uzakSekmeler);
  else uzakSekmeler();

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target && event.target.querySelector ? event.target.querySelector('.cshowcase') : null;
    if (section) window.setTimeout(function () { updateArrows(section); }, 300);
  });
})();
